export default {
	unknownErrorMessage: "An unknown error has occurred. Please contact Teaming for assistance.",
};



// WEBPACK FOOTER //
// ./src/lang/en/auth.js